import React from 'react';
import Page from 'components/Page';
import axios from 'axios';
import AppConstants from 'AppConstants';
import {ReactTitle} from 'react-meta-tags';
import  { Link } from 'react-router-dom';
import {
    Row,
    Col,Alert,
    Card,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
  } from 'reactstrap';
import Loading from 'assets/img/loader.gif';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Switch from "react-switch";
import { Multiselect } from 'multiselect-react-dropdown';
import CKEditor from "react-ckeditor-component";
var prg1 = []
class AddResource extends React.Component{
    constructor(){
        super();
        this.state = {
          title: "",
          pre_assessment: "",
          post_assessment: "",
          description: "",
          document: "",
          status: true,
          loading: "",
          errors: {},
          programs: [],
          seletedprogram: [],
          title_error: false,
          // pre_assessment_error: false,
          // post_assessment_error: false,
          description_error: false,
          status_error: false,
          prog_error: false,
          audio: "",
          video: "",
          thumbnail: "",
          media: "",
          file_type: "",
          content: "",
          audiolink: "",
          options: [
            { value: "Student", text: "Student", isChecked: false },
            { value: "Parent", text: "Parent", isChecked: false },
            { value: "Mentor", text: "Participant", isChecked: false },
          ],
          usertype_error: false,
          thumbnali_error: false,
          video_error: false,
          audio_error: false,
          note_color: "",
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleFileChange1 = this.handleFileChange1.bind(this);
        this.handleThumbnail = this.handleThumbnail.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleUsertpe = this.handleUsertpe.bind(this);
    }
    onChange(evt){
        // console.log(evt)
        var newContent = evt.editor.getData();
        this.setState({
          content: newContent
        })
        if (newContent) {
          this.setState({description_error:false})
        }
    }
    handleThumbnail(e){
        this.setState({thumbnail:e.target.files[0],thumbnail_error:false})
    }
    handleStatusChange(checked){
        this.setState({status : checked})
    }
    onSelect(selectedList, selectedItem) {
        this.setState({
          seletedprogram: selectedList
        });
        if(selectedList){
            this.setState({prog_error:false})
        }
    }
    onRemove(selectedList, removedItem) {
        if(selectedList == ""){
          this.setState({prog_error:true})
        }
    }
    handleFileChange(e){
        console.log(e.target.files[0])
        this.setState({document:e.target.files[0],document_error:false})
    }
    handleFileChange1(e){
        this.setState({audio:e.target.files[0],audio_error:false})
    }
    
    handleInputChange(e){
        if(e.target.name == 'file_type' && e.target.value == 'audio'){
            this.setState({ video : "",document : ""})
        }
        if(e.target.name == 'file_type' && e.target.value == 'video'){
            this.setState({ audio : "",document : "", audiolink : ""})
        }
        if(e.target.name == 'file_type' && e.target.value == 'document'){
            this.setState({ audio : "",video : "", audiolink : ""})
        }
//         file_type audio
//  file_type video
//  file_type document
        if(e.target.name == "title"){
            if(e.target.value != ""){
                this.setState({title_error:false,})
            }
        }
        // if(e.target.name == "pre_assessment"){
        //     if(e.target.value != ""){
        //         this.setState({pre_assessment_error:false,})
        //     }
        // }
        // if(e.target.name == "post_assessment"){
        //     if(e.target.value != ""){
        //         this.setState({post_assessment_error:false,})
        //     }
        // }
        if(e.target.name == "video"){
            if(e.target.value != ""){
                this.setState({video_error:false})
            }
        }
        if(e.target.name == "audiolink"){
            if(e.target.value != ""){
                this.setState({audio_error:false})
            }
        }
      
        if(e.target.name == "description"){
            this.setState({description_error:false});
        }
        this.setState({[e.target.name]:e.target.value})
        // if(this.state.media)
    }
    handleValidation(){
        let errors = {};
        let formIsValid = true;
        // if(this.state.audio  && this.state.audiolink){
        //     console.log("audio or video")
        //     formIsValid = false;
        //     errors["audio"] = "Please add audio link or upload audio file";
        //     // ReactDOM.findDOMNode(this.refs.video).focus();
        // }
        console.log("this.state.audio",this.state.audio.type)
        
        if(this.state.audio != '' && this.state.audiolink != ''){
            formIsValid = false;
            errors["audio"] = "Please enter either audiolink or audiofile but not both";
        }
        if(this.state.audio != '' && this.state.audio != undefined && (this.state.audio.type != "audio/mpeg")){
            formIsValid = false;
            errors["audio"] = "Please upload mp3 file";
            // ReactDOM.findDOMNode(this.refs.document1).focus();
        }
    
        if(this.state.document != '' && this.state.document != undefined && (this.state.document.type != "application/pdf" && this.state.document.type != "application/vnd.openxmlformats-officedocument.wordprocessingml.document")){
            formIsValid = false;
            errors["document"] = "Please upload pdf or document";
            // ReactDOM.findDOMNode(this.refs.document1).focus();
        }
       
        if(!this.state.document && !this.state.video && !this.state.audio && !this.state.audiolink){
            // this.setState({note_color:"#ff0000"})
            formIsValid = false;
            errors["note_color"] = "Please upload atleast one media file (Ex: audio | video | document).";
        }
       
        if(this.state.thumbnail && this.state.thumbnail.name && !this.state.thumbnail.name.match(/.(jpg|jpeg|png)$/i)){
            formIsValid = false;
            errors["thumbnail"] = "Please select valid image (Ex: jpg | jpeg | png )";
            // ReactDOM.findDOMNode(this.refs.thumbnail).focus();
        }
        if(this.state.seletedprogram.length==0){
            formIsValid = false;
            errors["seletedprogram"] = "Please select program";
        }
        if(!this.state.content){
            formIsValid = false;
            errors["description"] = "Please enter description";
            // ReactDOM.findDOMNode(this.refs.description).focus();
        }
        var user_tye = []
        this.state.options.map((option,i)=>{
            console.log(option.isChecked,option.value)
            if(option.isChecked == true){
                user_tye.push(option.value)
            }
        })
        if(user_tye.length == 0){
            formIsValid = false;
            errors["usertype"] = "Please select user type";
            // ReactDOM.findDOMNode(this.refs.usertype).focus();
        }
        if (!this.state.title){
            formIsValid = false;
            errors["title"] = "Please enter title";
            // ReactDOM.findDOMNode(this.refs.title).focus();
        }
        // if (!this.state.pre_assessment) {
        //   formIsValid = false;
        //   errors["pre_assessment"] = "Please enter Pre Assessment";
        // }
        // if (!this.state.post_assessment) {
        //   formIsValid = false;
        //   errors["post_assessment"] = "Please enter Post Assessment";
        // }
        if(this.state.audiolink && !/^https?:\/\//i.test(this.state.audiolink)){
            formIsValid = false;
            errors["audiourl"] = "Please enter valid URL";
          }
        if(this.state.video && !/^https?:\/\//i.test(this.state.video)){
            formIsValid = false;
            errors["url"] = "Please enter valid URL";
          }
        this.setState({
          errors: errors,
          title_error: true,
          // pre_assessment_error: true,
          // post_assessment_error: true,
          status_error: true,
          description_error: true,
          prog_error: true,
          usertype_error: true,
          thumbnail_error: true,
          document_error: true,
          video_error: true,
          audio_error: true,
          media_error: true,
        });
        return formIsValid;
    }
    handleSubmit(e){
        e.preventDefault();
        var user_tye = []
        this.state.options.map((option,i)=>{
            // console.log(option.isChecked,option.value)
            if(option.isChecked == true){
                user_tye.push(option.value)
            }
        })
        // console.log(this.state.seletedprogram)
        var prgs = []
        this.state.seletedprogram.map((prg,index)=>{
            prgs.push(prg.prg_id)
        })
        if(this.handleValidation()){
            this.setState({loading:1});
            console.log('pre_assessment', this.state.pre_assessment); 
            console.log('post_assessment', this.state.post_assessment); 
            let formData = new FormData();
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };
            formData.append('title', this.state.title);
            formData.append('description', this.state.content);
            formData.append('status', this.state.status);
            formData.append('program', JSON.stringify(prgs));
            formData.append('pre_assessment', this.state.pre_assessment); 
            formData.append('post_assessment', this.state.post_assessment); 
            formData.append('thumbnail', this.state.thumbnail);
            formData.append('media', this.state.media);
            formData.append('userType', JSON.stringify(user_tye));
            formData.append('audio', this.state.audio);
            formData.append('audiolink', this.state.audiolink);
            formData.append('video', this.state.video);
            formData.append('document',this.state.document);
            formData.append('file_type',this.state.file_type);
            axios.post(AppConstants.API+'/resource/addResource',formData,config)
                .then(res => { 
                    // console.log(res)
                    if(res.data.Status == "Success"){
                        setTimeout((e) => {
                            this.props.history.push('/resources');
                        }, 2000);
                        setTimeout(() => {
                          this.setState({
                            loading:'',
                            errMsg:  (<div className="alert alert-success fade show mt-3">{res.data.msg}</div>),
                          });
                        }, 1000);
                    }
                    else{
                        setTimeout(() => {
                          this.setState({
                            loading:'',
                            errMsg:  (<div className="alert alert-danger fade show mt-3">{res.data.msg}</div>),
                          });
                        }, 1000);
                    }
            })
        }
    }
    componentDidMount(){
        prg1 = [];
        fetch(AppConstants.API+'/programs/getAllactiveprograms').then(res=>{
            // console.log("resss",res.status);
            if(res.status == 200){
                return res.json();
            }
          }).then(result=>{
            // console.log("result.data",result.data);
            result.data.map((res,i)=>{
              var prg = {}
              prg["name"] = res.title
              prg["prg_id"] = res._id
              prg1.push(prg)
            })
            this.setState({programs:prg1})
          })
        var element = document.getElementById("navItem-Resources-0");
        element.classList.add("active");
    }
    handleUsertpe(event){
        let options = this.state.options
        options.forEach(option => {
           if (option.value === event.target.value)
            option.isChecked =  event.target.checked
        })
        this.setState({options: options,usertype_error:false});
    }
    render(){
        // console.log(this.state.options)
        const checkboxItems = this.state.options.map(planet => {
            return (<Label className="mx-3"><Input type="checkbox" name="usertype" onChange={this.handleUsertpe} value={planet.value} ref="usertype" class="form-control"></Input><span>{planet.text}</span></Label>);
        });
        return (
          <Page title="Add Resource" className="cms-edit">
            <ul className="cst-breadcrumb">
              <li>
                <Link to={"/dashboard"}>Dashboard</Link>
              </li>
              <li>
                <Link to={"/resources"}>All Resources</Link>
              </li>
              <li>Add Resource</li>
            </ul>
            <ReactTitle title="Add Resource" />
            <Row>
              <Col xl={12} lg={12} md={12}>
                <Card>
                  <CardBody>
                    <Form name="addresource" onSubmit={this.handleSubmit}>
                      <FormGroup row>
                        <Label for="title" sm={2}>
                          Title<span>*</span>
                        </Label>
                        <Col sm={10}>
                          <Input
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={this.state.title}
                            onChange={this.handleInputChange}
                            ref="title"
                          />
                          {this.state.title_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["title"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="usertype" sm={2}>
                          User type<span>*</span>
                        </Label>
                        <Col sm={10}>
                          <div className="ml-2"> {checkboxItems}</div>
                          {this.state.usertype_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["usertype"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="Description" sm={2}>
                          Description<span>*</span>
                        </Label>
                        <Col sm={10}>
                          <CKEditor
                            activeClass="editor12"
                            content={this.state.content}
                            events={{
                              blur: this.onBlur,
                              afterPaste: this.afterPaste,
                              change: this.onChange,
                            }}
                            ref="description"
                          />
                          {this.state.description_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["description"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="program" sm={2}>
                          Program <span>*</span>
                        </Label>
                        <Col sm={10}>
                          <div>
                            <Multiselect
                              options={this.state.programs} // Options to display in the dropdown
                              selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                              onSelect={this.onSelect} // Function will trigger on select event
                              onRemove={this.onRemove} // Function will trigger on remove event
                              displayValue="name" // Property name to display in the dropdown options
                              placeholder="Program"
                            />
                          </div>
                          {this.state.prog_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["seletedprogram"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label for="pre_assessment" sm={2}>
                          Pre assessment 
                          {/* <span>*</span> */}
                        </Label>
                        <Col sm={10}>
                          <Input
                            type="text"
                            name="pre_assessment"
                            placeholder="Pre Assessment"
                            value={this.state.pre_assessment}
                            onChange={this.handleInputChange}
                            ref="pre_assessment"
                          />
                          {/* {this.state.pre_assessment_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["pre_assessment"]}
                            </span>
                          ) : (
                            ""
                          )} */}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label for="post_assessment" sm={2}>
                          Post assessment 
                          {/* <span>*</span> */}
                        </Label>
                        <Col sm={10}>
                          <Input
                            type="text"
                            name="post_assessment"
                            placeholder="Post Assessment"
                            value={this.state.post_assessment}
                            onChange={this.handleInputChange}
                            ref="post_assessment"
                          />
                          {/* {this.state.post_assessment_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["post_assessment"]}
                            </span>
                          ) : (
                            ""
                          )} */}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="thumbnail" sm={2}>
                          Thumbnail
                        </Label>
                        <Col sm={10}>
                          <Input
                            type="file"
                            name="thumbnail"
                            placeholder="Upload Audio file"
                            // value={this.state.thumbnail}
                            onChange={this.handleThumbnail}
                            ref="thumbnail"
                          />
                          {this.state.thumbnail_error == true ? (
                            <span className="error" style={{ color: "red" }}>
                              {this.state.errors["thumbnail"]}
                            </span>
                          ) : (
                            ""
                          )}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm={2} for="Eligibility requirements needed">
                          File Type<span>*</span>
                        </Label>
                        <Col sm={10}>
                          <div className="form-check-inline">
                            <div className="form-check p-0">
                              <Label className="form-check-label ">
                                <Input
                                  name="file_type"
                                  type="radio"
                                  className="form-check-input"
                                  value="audio"
                                  checked={this.state.file_type == "audio"}
                                  onChange={this.handleInputChange}
                                />
                                Audio{" "}
                              </Label>
                            </div>

                            <div className="form-check">
                              <Label className="form-check-label">
                                <Input
                                  name="file_type"
                                  type="radio"
                                  className="form-check-input"
                                  value="video"
                                  checked={this.state.file_type == "video"}
                                  onChange={this.handleInputChange}
                                />
                                Video
                              </Label>
                            </div>

                            <div className="form-check">
                              <Label className="form-check-label">
                                <Input
                                  name="file_type"
                                  type="radio"
                                  className="form-check-input"
                                  value="document"
                                  checked={this.state.file_type == "document"}
                                  onChange={this.handleInputChange}
                                />
                                Document
                              </Label>
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                      {this.state.file_type == "audio" ? (
                        <div>
                          <FormGroup row>
                            <Label for="audio" sm={2}>
                              Audio Link
                            </Label>
                            <Col sm={10}>
                              <Input
                                type="text"
                                name="audiolink"
                                placeholder="Audio link"
                                value={this.state.audiolink}
                                onChange={this.handleInputChange}
                                ref="audiolink"
                              />
                              <span className="error">{this.state.errors["audiourl"]}</span>
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label for="audio" sm={2}>
                              Audio File
                            </Label>
                            <Col sm={10}>
                              <Input
                                type="file"
                                name="audio"
                                placeholder="Upload Audio file"
                                // value={this.state.audio}
                                onChange={this.handleFileChange1}
                                ref="audio"
                              />
                              <span className="error" style={{ color: "red" }}>
                                {this.state.errors["audio"]}
                              </span>
                            </Col>
                          </FormGroup>
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.file_type == "video" ? (
                        <FormGroup row>
                          <Label for="video" sm={2}>
                            Video Link
                          </Label>
                          <Col sm={10}>
                            <Input
                              type="text"
                              name="video"
                              placeholder="Video Link"
                              value={this.state.video}
                              onChange={this.handleInputChange}
                              ref="video"
                            />
                            {this.state.video_error == true ? (
                              <span className="error" style={{ color: "red" }}>
                                {this.state.errors["video"]}
                              </span>
                            ) : (
                              ""
                            )}
                            <span className="error">{this.state.errors["url"]}</span>
                          </Col>
                        </FormGroup>
                      ) : (
                        ""
                      )}
                      {this.state.file_type == "document" ? (
                        <FormGroup row>
                          <Label for="title" sm={2}>
                            Upload Document
                          </Label>
                          <Col sm={10}>
                            <Input
                              type="file"
                              name="document"
                              placeholder="Upload Pdf document"
                              //value={this.state.document}
                              onChange={this.handleFileChange}
                              ref="document1"
                            />
                            {this.state.document_error == true ? (
                              <span className="error" style={{ color: "red" }}>
                                {this.state.errors["document"]}
                              </span>
                            ) : (
                              ""
                            )}
                          </Col>
                        </FormGroup>
                      ) : (
                        ""
                      )}
                      <FormGroup row>
                        <Label for="status" sm={2}>
                          Status
                        </Label>
                        <Col sm={10}>
                          <Switch
                            onChange={this.handleStatusChange.bind(this)}
                            checked={this.state.status}
                            uncheckedIcon={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  fontSize: 15,
                                  width: "150px",
                                  color: "#000",
                                  fontWeight: "bold",
                                  paddingRight: 2,
                                }}
                              >
                                Inactive
                              </div>
                            }
                            checkedIcon={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  fontSize: 15,
                                  width: "180px",
                                  fontWeight: "bold",
                                  color: "#000",
                                  paddingRight: 2,
                                }}
                              >
                                Active
                              </div>
                            }
                            onColor="#45b649"
                            offColor="#ffd700"
                            className="react-switch"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            handleDiameter={30}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="status" sm={2}>
                          &nbsp;
                        </Label>
                        <Col sm={10}>
                          {this.state.errors["note_color"] ? (
                            <Alert color="danger">Note: {this.state.errors["note_color"]}</Alert>
                          ) : (
                            <Alert color="warning">Note: Please upload atleast one media file.</Alert>
                          )}
                        </Col>
                      </FormGroup>

                      <FormGroup check row>
                        <Col sm={{ size: 10, offset: 2 }}>
                          <Button className="btn btn-primary" onClick={this.handleSubmit}>
                            Save{" "}
                            <div
                              style={this.state.loading ? {} : { display: "none" }}
                              className="image-fill w-25 loader-div"
                            >
                              <img src={Loading} alt="No Image" className="can-click " />
                            </div>
                          </Button>
                          &nbsp;
                          <Link to={"/resources"} className="btn btn-danger" title="Cancel">
                            &nbsp;Cancel
                          </Link>
                        </Col>
                      </FormGroup>
                      {this.state.errMsg}
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Page>
        );
    }
}
AddResource.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors
})
export  default connect(mapStateToProps, {})(AddResource);